import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserService } from '../shared';
import { environment } from '../shared/config/app-config';

@Component({
  selector: 'app-sucesstemp',
  templateUrl: './sessiontemp.component.html',
  styleUrls: ['./sessiontemp.component.css']
})
export class SessiontempComponent implements OnInit {
  @Input() count: number;
  @Input() doubleSessionActive: boolean;
  @Input() userDetails: any;
  @Input() showOutOfOffice: boolean;
  @Input() showEmail: boolean;
  @Input() doubleSessionmessage: string;
  @Input() countMinutes: number;
  @Input() countSeconds: number;
  @Input() progressCount: number;
  @Input() ocUser: boolean;
  public imageURL: string = environment.cloudeImageURL;
  authForm: FormGroup;
  type: string = 'email';
  setmask: any = ''
  code: any;
  continueClick= false;
  errorMsg = false;
  constructor(public dialogRef: MatDialogRef<SessiontempComponent>, public router: Router, @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, private userService: UserService, private cdr: ChangeDetectorRef) {
    this.authForm = this.fb.group({
      'username': ['', Validators.required],
      'code': ['']
    });
  }


  ngOnInit() {
  }
  continue(): void {
    return this.dialogRef.close('');

  }
  logout(): void {
    return this.dialogRef.close('logout');
  }

  closeYesSkip(text): void {
    return this.dialogRef.close(text);
  }
  
  closeEmail(text): void {
    if(text !== '' && (this.authForm.value.username)) {
      let userName = this.authForm.value.username;
      if (this.authForm.value.code) {
        userName = this.authForm.value.code + '-' + this.authForm.value.username
      }
      const credential = {
        'userName': userName
      }
      this.userService.getLanguageConfig(credential).subscribe(
        langConfigRes => {
        if(langConfigRes && langConfigRes.hasOwnProperty("multiLanguageRequired")) {
          if(langConfigRes?.multiLanguageRequired) {
            sessionStorage.setItem("backToPage",JSON.stringify({"currentURL" : this.router.url, "currentLang": this.userService.selectedLang()}))
            this.userService.setCurrentLanguage(langConfigRes?.preferredlanguage);
            localStorage.setItem("UserEmail", this.authForm.value.username);
            localStorage.setItem("LanguageConfig", JSON.stringify(langConfigRes));
            this.router.navigateByUrl(`/need-help`);
            this.errorMsg = false;
            this.dialogRef.close(this.authForm.value.username);
          } 
        } else {
          this.errorMsg = true;
          this.cdr.markForCheck(); 
        }
      });
      
    }

    if(text === '')  return this.dialogRef.close('');
  }

  setvalue() {
    if (this.type != 'number') {
      return false
    } {
      return true
    }
  }

  checkphone(code) {
    if (this.type == 'number') {
      if (code == "44") {
        this.setmask = '00000 000000'
      } else {
        this.setmask = '(000) 000-0000'
      }
    }
  }

  public customPatterns = { 'A': { pattern: new RegExp('\[a-zA-Z0-9._@+-\]') }, '0': { pattern: new RegExp('\[0-9\]') } };
  Onchange(event) {
    this.continueClick = false
    if (event.keyCode != 8) {
      let targetvalue = event.target.value.replace(/[^a-zA-Z0-9._@+]/g, '');
      let keyvalue;
      if (event.key)
        keyvalue = event.key.replace(/[^a-zA-Z0-9._@+]/g, '');
      //if ((isNaN(targetvalue) || targetvalue == '') || (isNaN(keyvalue) || keyvalue == '')) {
      if (isNaN(targetvalue) || targetvalue == '' || isNaN(keyvalue) || keyvalue == '') {
        this.setmask = "A*"
        this.type = 'email'
      } else
        this.type = 'number'
    }
    else {
      if (event.target.value.length <= 0) {
        this.type = 'email'
        this.setmask = "A*"
      }
    }
    if (this.type == 'email')
      this.code = undefined
    else {
      if (this.code == '1' || this.code == undefined || this.code == null) {
        this.code = '1'
        this.checkphone('1')
      }
      else {
        this.checkphone(this.code)
      }
    }
  }
  patchUserName() {
    if(this.authForm.value.username && this.authForm.value.username.length > 1) {
      this.authForm.patchValue({username:''});
    }
  }
}
